import { FlatOption } from 'pages/AuditLogs/types';

const getIdFromBusinessEntitySelection = (selection: FlatOption) => 
// The value is in the format `${kind}-${id}`, so we split by '-' and take the last part as the ID
   selection.value.split('-').at(-1) as string
;

export default getIdFromBusinessEntitySelection;
